// extracted by mini-css-extract-plugin
export default {"button":"mpXtLy8xSI"};